import { BoxProps, ColorOptions, TextInputNewProps } from '@jfs/ui-new'

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.2,
  shadowRadius: 4,
}

export const styles = {
  mainView: {
    flex: 1,
    backgroundColor: 'BACKGROUND_LIGHT',
    p: 20,
    pt: 30,
  } as BoxProps,
  textInputStyle: {
    borderColor: 'BORDER_COLOR' as ColorOptions,
    borderRadius: 6,
    fontFamily: 'jiotype-medium',
    labelColor: 'BLACK_21' as ColorOptions,
    fontSize: 14,
    paddingHorizontal: 8,
    focusBorderColor: 'PRIMARY' as ColorOptions,
    borderWidth: 1,
    paddingVertical: 8,
    onFocusBorderWidth: 1.5,
  } as TextInputNewProps,
  container: {
    underlayColor: 'WHITE',
    overflow: 'scroll',
    bg: 'WHITE',
    padding: 'MEDIUM',
    backgroundColor: 'WHITE',
    borderWidth: 1,
    borderRadius: 12,
    borderTopWidth: 0,
    paddingTop: 30,
    paddingBottom: 30,
    borderColor: '#e3e6f0' as ColorOptions,
    ...shadow,
  } as BoxProps,
  formContainer: {
    width: '100%',
    borderRadius: 12,
    pt: 32,
  } as BoxProps,
}
